import { render, staticRenderFns } from "./claim_detail.vue?vue&type=template&id=5675bc7e&scoped=true&"
import script from "./claim_detail.vue?vue&type=script&lang=js&"
export * from "./claim_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675bc7e",
  null
  
)

export default component.exports